import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as c } from "../../../../IconBase-CxZyIWw2.js";
const o = r((a, e) => /* @__PURE__ */ s.jsx(
  c,
  {
    ref: e,
    ...a,
    image: (l) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...l,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_4108",
              width: 22,
              height: 22,
              x: 13,
              y: 13,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M34.68 13.181a.763.763 0 0 0-1.01.02l-.03.03c-.3.26-2.57 2.11-6.24 1.17a.75.75 0 0 0-.37 1.45c1.47.38 2.76.37 3.84.19l-4.65 4.7a8.03 8.03 0 0 0-5.16-1.88c-4.45.01-8.06 3.63-8.06 8.07s3.61 8.06 8.06 8.06 8.05-3.61 8.05-8.06c0-1.94-.69-3.72-1.83-5.11l4.81-4.86c-.09 1.03.02 2.25.51 3.69.11.31.4.5.71.5a.75.75 0 0 0 .71-1c-1.33-3.81.61-5.77.7-5.86l-.02-.01c.07-.06.1-.1.1-.1.23-.31.17-.74-.12-1m-13.62 20.3c-3.61 0-6.56-2.94-6.56-6.56 0-3.61 2.94-6.55 6.56-6.55a6.56 6.56 0 0 1 6.55 6.55c0 3.62-2.94 6.56-6.55 6.56"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_4108)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h48v48H0z" }) })
        ]
      }
    )
  }
));
o.displayName = "AgencyMaleIcon";
export {
  o as AgencyMaleIcon,
  o as default
};
//# sourceMappingURL=index.js.map
